const countriesDE = require('./countries-de_DE.json')

export default {
    countriesDE,
}



// WEBPACK FOOTER //
// ./src/components/utilities/helper/Country/index.js